<template>
	<div>
		<el-dialog
			:close-on-click-modal="false"
			:show-close="false"
			:visible.sync="isShowHint"
			append-to-body
			center
			title="提示"
			top="40vh"
			width="35%">
			<span style="font-weight: bold">请确认该个体工商户是否有对公账户？</span>
			<div style="margin-top: 5px"></div>
			<template slot="footer">
				<el-button plain type="primary" @click="onHaveAccount()">没有对公账户</el-button>
				<el-button type="primary" @click="onHaveAccount(1)">有对公账户</el-button>
			</template>
		</el-dialog>

		<el-dialog
			:close-on-click-modal="false"
			:show-close="false"
			:visible.sync="isShowYes"
			append-to-body
			center
			title="提示"
			top="40vh"
			width="35%">
			<span style="font-weight: bold">雇主险与团意险都要求客户开设对公账户才能投保本平台方案！</span>
			<div style="margin-top: 5px">
				<el-checkbox v-model="isRead">我已知悉并告知客户须有对公账户才能投保</el-checkbox>
			</div>
			<template slot="footer">
				<el-button :disabled="!isRead" type="primary" @click="onSure(1)">确定</el-button>
			</template>
		</el-dialog>
		<el-dialog
			:close-on-click-modal="false"
			:show-close="false"
			:visible.sync="isShowNo"
			append-to-bodycenter
			title="提示"
			top="40vh"
			width="35%">
			<span style="font-weight: bold">
				客户没有对公账户将影响后续的理赔或特殊情况退保处理，请向客户做好告知提醒，须客户后续及时开设对公账户方能投保！
			</span>
			<div style="margin-top: 5px">
				<el-checkbox v-model="isRead">我已知悉并告知客户须有对公账户才能投保</el-checkbox>
			</div>
			<template slot="footer">
				<el-button :disabled="!isRead" type="primary" @click="onSure(2)">确定</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

export default {
	name: 'getiBusinessDialog',
	mixins: [],
	components: {},
	props: {},
	data() {
		return {
			isShowHint: false,
			isShowYes: false,
			isShowNo: false,
			isRead: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		showGetiHint() {
			this.isShowHint = true
			// this.$confirm('请确认客户个体工商户是否有对公账户？', '提醒', {
			//   cancelButtonText: '没有对公账户',
			//   confirmButtonText: '有',
			//   closeOnClickModal: false,
			//   closeOnPressEscape: false,
			//   showClose: false,
			//   closeOnHashChange: false
			// }).then(() => {
			//   this.isShowYes = true
			// }).catch(() => {
			//   this.isShowNo = true
			// })
		},
		onHaveAccount(type = 0) {
			if (type === 1) {
				this.isShowYes = true
			} else {
				this.isShowNo = true
			}
			this.isShowHint = false
		},
		onSure() {
			this.isRead = false
			this.isShowYes = false
			this.isShowNo = false
			this.$emit('onGetiSure')
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 15px 30px;
}

::v-deep .el-checkbox__label {
	margin-top: 4px;
}
</style>
